export default "__VITE_ASSET__c8299af7__"